import React from "react";

export default function ErrorPage() {
  return (
    <>
      <h1>404 error</h1>
      <p>Page doesnot exist</p>
    </>
  );
}
